/* globals logLevels */
import {
  fetchConfig,
  ingestConfig,
  ingestUtmValues,
  prefetchAssets
} from '../utils/machine_utils/FunnelMachine.utils'
import broadcast from '../utils/subscription_utils/broadcast'
import { assign, createMachine, send } from 'xstate'
import { prepareResponses } from '../utils/machine_utils/QuestionMachine.utils'
import Logger from '../utils/logger/logger'
import { broadcastEvents, funnelEvents } from '../events/eventMap'

export const funnelMachineDeclaration = {
  id: 'funnel',
  initial: 'loading',
  predictableActionArguments: true,
  context: {
    config_version: '',
    config_date: '',
    responses: [],
    accordion_active: false,
    configUrl: '',
    userId: '',
    sessionUUID: '',
    startEnabled: true,
    question_groups: [],
    eventSubscriptions: {},
    postFunnelExperienceConfig: {},
    introduction: {},
    utmString: '',
    utm: {},
    retarget: {},
    retargetSession: true,
    interfaceOptions: {},
    introEnabled: false
  },
  on: {
    [funnelEvents.start]: {
      target: 'started',
      actions: 'logStart'
    },
    [funnelEvents.questionMachineReady]: {
      actions: ['accordionClose']
    },
    [funnelEvents.accordionToggle]: {
      actions: ['accordionToggle', 'broadcastAccordionToggle']
    },
    [funnelEvents.accordionClose]: {
      actions: ['accordionClose']
    }
  },
  states: {
    loading: {
      invoke: {
        id: 'fetchConfig',
        src: 'fetchConfig',
        onDone: [{
          target: 'idle',
          actions: ['ingestConfig', 'loadUtmValues', 'prefetchAssets'],
          cond: 'startLandingEnabled'
        },
        {
          target: 'intro',
          actions: ['ingestConfig', 'loadUtmValues', 'prefetchAssets'],
          cond: 'startIntroEnabled'
        },
        {
          target: 'autoStarting',
          actions: ['ingestConfig', 'loadUtmValues', 'prefetchAssets']
        }],
        onError: {
          target: 'errorLoading',
          actions: ['logConfigError']
        }
      }
    },
    errorLoading: {
      type: 'final'
    },
    idle: {},
    intro: {},
    autoStarting: {
      entry: 'startQuestions'
    },
    started: {
      invoke: {
        id: 'questionMachine',
        src: 'questionMachine',
        data: ctx => ({
          eventSubscriptions: ctx.eventSubscriptions,
          question_groups: ctx.question_groups,
          responses: ctx.responses,
          autofocus_enabled: false, // this invocation happens only on first question; do not autofocus input on first question
          userId: ctx.userId,
          sessionUUID: ctx.sessionUUID,
          utm: ctx.utm,
          postFunnelExperienceConfig: ctx.postFunnelExperienceConfig
        }),
        onDone: [
          {
            target: 'loading',
            actions: ['changeConfigUrl', 'saveResponses'],
            cond: 'isConfigChanging'
          }
        ]
      }
    }
  }
}

export const funnelMachineOptions = {
  services: {
    fetchConfig: async (ctx) => fetchConfig(ctx)
  },
  actions: {
    loadUtmValues: assign((ctx) => ingestUtmValues(ctx)),
    startQuestions: send(funnelEvents.start),
    saveResponses: assign({
      responses: (ctx, event) => ([
        ...ctx.responses,
        ...prepareResponses(event.data.question_groups)
      ])
    }),
    ingestConfig: assign((ctx, event) => ingestConfig(ctx, event)),
    changeConfigUrl: assign((ctx, event) => ({
      configUrl: event.data.targetConfigUrl
    })),
    prefetchAssets: (ctx) => prefetchAssets(ctx),
    logStart: (ctx) => broadcast(broadcastEvents.funnelStart, {}, ctx),
    logConfigError: (ctx) => broadcast(broadcastEvents.configError, {
      config_filename: ctx.configUrl
    }, ctx),
    accordionClose: assign({
      accordion_active: false
    }),
    accordionToggle: assign({
      accordion_active: (ctx) => !ctx.accordion_active
    }),
    broadcastAccordionToggle: (ctx, event) => {
      broadcast('ACCORDION_TOGGLE', event.data, ctx)
      Logger.log(logLevels.TRACE, 'Accordion click/toggle', event, ctx)
    }
  },
  guards: {
    startLandingEnabled: (ctx) => ctx.startEnabled,
    isConfigChanging: (ctx, event) => !!event.data?.targetConfigUrl,
    startIntroEnabled: (ctx) => ctx.introEnabled
  }
}

export const funnelMachine = createMachine(funnelMachineDeclaration, funnelMachineOptions)
